module.exports = __webpack_public_path__ + "img/choice.619eb874.svg";